import styled from "styled-components"
import { Link } from "react-router-dom"
import Div100vh from "react-div-100vh"

export const Holder = styled(Div100vh)`
  position: fixed;
  width: 100vw;
  height: 100%;
  background-color: #d0c6c8;
`
export const BackButton = styled(Link)`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
`
export const Content = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
